module.exports = __webpack_public_path__ + "img/industry-standard.9bcef4a5.png";